/* FUKUI theme — product page JS
   Gallery, variant picker (width buttons + finish swatches), quantity,
   AJAX add to cart, delivery estimator, closer-look tabs,
   compare slider. The drawings themselves live in drawing.js. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var dataEl = document.getElementById('ProductJSON');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var money = window.FUKUI.formatMoney;

    /* ── gallery ──
       Two stacked images instead of one. A new photo is loaded into the back
       layer and only crossfaded in once the browser says it is decoded, so the
       frame never flashes white and never shows half a picture. The finish
       swatches come through here too (a variant carries its own media), which
       is what turns "the page swapped a file" into "the piece changed colour". */
    var gi = 0;
    var thumbs = $$('#thumbs button');
    var stageImg = $('#stageImg');
    var galCnt = $('#galCnt');
    var dimStage = $('#dimStage');
    var dimSvg = document.getElementById('dimSvg');
    var FADE = 280;
    var motionOK = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var layers = null, front = 0, swapTimer = null;

    function galLayers() {
      if (layers || !stageImg) return layers;
      var back = stageImg.cloneNode(false);
      back.removeAttribute('id');
      back.removeAttribute('src');
      back.removeAttribute('srcset');
      back.alt = '';
      back.setAttribute('aria-hidden', 'true');
      back.style.opacity = '0';
      stageImg.parentNode.insertBefore(back, stageImg.nextSibling);
      layers = [stageImg, back];
      return layers;
    }
    function paint(el, btn) {
      el.srcset = btn.dataset.set || '';
      el.src = btn.dataset.full;
      var t = btn.querySelector('img');
      el.alt = t ? t.alt : '';
    }
    function resolved(u) { var a = document.createElement('a'); a.href = u || ''; return a.href; }
    function crossfade(btn) {
      var L = galLayers();
      if (!L) return;
      var cur = L[front], back = L[1 - front];
      if (cur.src && cur.src === resolved(btn.dataset.full)) return;   /* already showing it */
      if (!motionOK) { paint(cur, btn); return; }
      if (swapTimer) { clearTimeout(swapTimer); swapTimer = null; }
      paint(back, btn);
      /* the state change hangs on a timer, not on a frame callback: a
         backgrounded tab stops painting, and the gallery must not stop with it */
      var run = function () {
        back.style.transition = 'none';
        back.style.opacity = '0';
        void back.offsetWidth;                       /* flush, so the fade starts at 0 */
        back.style.transition = 'opacity ' + FADE + 'ms ease';
        cur.style.transition = 'opacity ' + FADE + 'ms ease';
        back.style.opacity = '1';
        cur.style.opacity = '0';
        back.removeAttribute('aria-hidden');
        cur.setAttribute('aria-hidden', 'true');
        front = 1 - front;
        swapTimer = setTimeout(function () {
          swapTimer = null;
          back.style.transition = '';
          cur.style.transition = '';
          cur.alt = '';                              /* only the visible layer is described */
        }, FADE + 40);
      };
      /* Whichever signal comes first wins. decode() gives the cleanest fade — the
         picture is ready before it is shown — but a tab that is not painting can
         leave that promise unsettled for ever, and the gallery would sit on the
         old photograph. So load/error and a hard 700 ms floor race alongside it. */
      var done = false;
      var go = function () { if (!done) { done = true; run(); } };
      if (back.complete && back.naturalWidth) { go(); }
      else {
        back.addEventListener('load', go, { once: true });
        back.addEventListener('error', go, { once: true });
        if (back.decode) back.decode().then(go, go);
        setTimeout(go, 700);
      }
    }

    function show(i) {
      if (!thumbs.length) return;
      gi = (i + thumbs.length) % thumbs.length;
      var btn = thumbs[gi];
      var isDim = btn.dataset.dim === '1';
      if (dimStage) dimStage.hidden = !isDim;
      if (stageImg) {
        (layers || [stageImg]).forEach(function (l) { l.hidden = isDim; });
        if (!isDim) crossfade(btn);
      }
      if (isDim && window.FUKUIDraw) window.FUKUIDraw.redraw(dimSvg);
      if (galCnt) galCnt.textContent = (gi + 1) + ' / ' + thumbs.length;
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', String(j === gi)); });
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    var gPrev = $('#gPrev'), gNext = $('#gNext');
    if (gPrev) gPrev.addEventListener('click', function () { show(gi - 1); });
    if (gNext) gNext.addEventListener('click', function () { show(gi + 1); });
    addEventListener('keydown', function (e) {
      if (e.target.closest('input,textarea,select')) return;
      if (e.key === 'ArrowRight') show(gi + 1);
      if (e.key === 'ArrowLeft') show(gi - 1);
    });
    var stage = $('#stage'), tx = 0;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var d = e.changedTouches[0].clientX - tx;
        if (Math.abs(d) > 40) show(gi + (d < 0 ? 1 : -1));
      });
    }

    /* ── variant selection ── */
    var selected = product.variants.filter(function (v) { return v.id === product.selected_variant_id; })[0] || product.variants[0];
    var options = selected ? selected.options.slice() : [];
    var qty = 1;

    function currentVariant() {
      return product.variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === options[i]; });
      })[0] || null;
    }

    function update() {
      var v = currentVariant();
      var priceV = $('#priceV'), priceR = $('#priceR'), pricePct = $('#pricePct'), offTop = $('#offTop');
      /* the buy strip sits outside [data-product-root], so the scoped $ misses it */
      var addBtn = $('#addBtn'), addP = $('#addP');
      /* the buy strip is fed from here too, so the two can never disagree */
      var hbP = document.getElementById('hbP');
      var idInput = $('input[name="id"]');
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceV) priceV.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceR) { priceR.hidden = !onSale; if (onSale) priceR.textContent = money(v.compare_at_price); }
        var pct = onSale ? '−' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%' : '';
        if (pricePct) { pricePct.hidden = !onSale; pricePct.textContent = pct; }
        if (offTop) { offTop.hidden = !onSale; offTop.textContent = pct; }
        if (addP) addP.textContent = money(v.price * qty);
        if (hbP) hbP.textContent = money(v.price * qty);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.querySelector('[data-atc-text]').textContent = v.available ? (addBtn.dataset.textAdd || 'Add to cart') : (addBtn.dataset.textSoldout || 'Sold out');
        }
        var sku = $('#sSku'); if (sku && v.sku) sku.textContent = v.sku;
        if (v.featured_media_position) show(v.featured_media_position - 1);
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.querySelector('[data-atc-text]').textContent = addBtn.dataset.textUnavailable || 'Unavailable';
      }
      // option labels + iso width
      document.querySelectorAll('[data-option-label]').forEach(function (el) {
        el.textContent = options[parseInt(el.dataset.optionLabel, 10)] || '';
      });
      // finish description under the swatches
      document.querySelectorAll('[data-finish-desc]').forEach(function (el) {
        el.hidden = options.indexOf(el.dataset.finishDesc) === -1;
      });
      // instalments line
      var klarnaEl = document.getElementById('klarna');
      if (klarnaEl && v) {
        var n = parseInt(klarnaEl.dataset.count || '3', 10);
        klarnaEl.textContent = n + ' × ' + money(Math.round(v.price / n));
      }
      // "make it a pair" price
      var pairEl = document.getElementById('pair');
      var pairP = document.getElementById('pairP');
      if (pairEl && pairP && v) {
        var pairPct = parseFloat(pairEl.dataset.pct || '5');
        pairP.textContent = money(Math.round(v.price * 2 * (100 - pairPct) / 100));
      }
      // generated drawings: redraw at the width of the selected variant
      var widthVal = null;
      options.forEach(function (val) { var m = /^(\d+)/.exec(val || ''); if (m && !widthVal) widthVal = parseInt(m[1], 10); });
      document.querySelectorAll('svg[data-style][data-kind]').forEach(function (sv) {
        if (widthVal) sv.dataset.w = widthVal;
        if (window.FUKUIDraw) window.FUKUIDraw.redraw(sv);
      });
      var qtyEl = $('#qty'); if (qtyEl) qtyEl.textContent = qty;
      document.dispatchEvent(new CustomEvent('fukui:variant:change', { detail: { variant: v, quantity: qty } }));
    }

    $$('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.dataset.optionIndex, 10);
        options[i] = btn.dataset.value;
        $$('[data-option-index="' + i + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.value === options[i]));
        });
        update();
      });
    });

    var qPlus = $('#qPlus'), qMinus = $('#qMinus');
    var pairBox = document.getElementById('pair');
    if (qPlus) qPlus.addEventListener('click', function () { qty = Math.min(9, qty + 1); update(); });
    if (qMinus) qMinus.addEventListener('click', function () { qty = Math.max(1, qty - 1); if (pairBox && qty < 2) pairBox.checked = false; update(); });
    if (pairBox) pairBox.addEventListener('change', function () { qty = pairBox.checked ? 2 : 1; update(); });

    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available) return;
      window.FUKUI.cart.add({ id: v.id, quantity: qty }).catch(function (err) {
        window.FUKUI.toast((err && err.description) || 'Could not add to cart.');
      });
    }
    var addBtn = $('#addBtn'); if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    var hbAdd = document.getElementById('hbAdd'); if (hbAdd) hbAdd.addEventListener('click', addToCart);

    /* ── finish cards (section below) select the matching option value ── */
    document.querySelectorAll('.finbtn[data-name]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = $$('[data-option-index]').filter(function (x) { return x.dataset.value === b.dataset.name; })[0];
        if (target) target.click();
        document.querySelectorAll('.finbtn').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var buy = document.querySelector('.buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ── samples upsell ── */
    var sampleBtn = document.getElementById('sampleBtn');
    if (sampleBtn && sampleBtn.dataset.variantId) {
      sampleBtn.addEventListener('click', function () {
        window.FUKUI.cart.add({ id: parseInt(sampleBtn.dataset.variantId, 10), quantity: 1 }).then(function () {
          window.FUKUI.toast('Finish samples added');
        }).catch(function () { window.FUKUI.toast('Could not add samples.'); });
      });
    }

    /* ── delivery estimator ── */
    var country = document.getElementById('country');
    function busDays(from, n) {
      var d = new Date(from), k = 0;
      while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; }
      return d;
    }
    function fmt(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
    function deliv() {
      if (!country) return;
      var o = country.selectedOptions[0];
      var parts = (o.dataset.d || '2-4').split('-').map(Number);
      var prodMin = parseInt(country.dataset.prodMin || '2', 10);
      var prodMax = parseInt(country.dataset.prodMax || '3', 10);
      var t = new Date();
      var lo = busDays(t, prodMin + parts[0]), hi = busDays(t, prodMax + parts[1]);
      var range = document.getElementById('dateRange');
      if (range) range.textContent = fmt(lo) + ' – ' + fmt(hi);
      var note = document.getElementById('delivNote');
      if (note) note.textContent = o.dataset.note || '';
    }
    if (country) { country.addEventListener('change', deliv); deliv(); }

    /* ── closer-look tabs ── */
    document.querySelectorAll('.look .tab').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.look .tab').forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        var img = document.getElementById('lookImg');
        if (img && t.dataset.img) { img.srcset = t.dataset.set || ''; img.src = t.dataset.img; }
      });
    });

    /* ── compare slider ── */
    var cmp = document.getElementById('compare');
    if (cmp) {
      var input = cmp.querySelector('input');
      if (input) input.addEventListener('input', function (e) { cmp.style.setProperty('--x', e.target.value + '%'); });
    }

    /* The star line under the subtitle needs no JavaScript. It is rendered by
       snippets/review-stars.liquid from the same cached Judge.me markup the
       widget itself renders from, so the two cannot disagree, and there is
       nothing here left to reconcile. */

    update();
  });
})();
